import { useState } from 'react';
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  TextField,
} from '@mui/material';

const Step3 = ({ formData = {}, setFormData, errors = {}, setErrors }) => {
  const handleRadioChange = (event) => {
    setFormData({ ...formData, selectedValue: event.target.value });

    // Clear errors when user selects an option
    setErrors((prevErrors) => ({ ...prevErrors, selectedValue: '' }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });

    setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };

  return (
    <div>
      <span>
        უნდა მიეთითოს დაზარალებულის ან იმ პირთა მონაცემები, ვინც რაიმე სახის
        რისკის წინაშე დადგა პროდუქტის გამოყენებისას. ეს ინფორმაცია დაეხმარება
        ბაზარზე ზედამხედველობის სააგენტოს პროდუქტის პოტენციური საფრთხის
        განსაზღვრაში.
      </span>

      <FormControl component='fieldset' error={!!errors.selectedValue}>
        <br />
        <span>მოჰყვა თუ არა პროდუქტის გამოყენებას ადამიანის დაზიანება?</span>
        <RadioGroup
          row
          value={formData.selectedValue || 'არა'}
          onChange={handleRadioChange}
        >
          <FormControlLabel value='კი' control={<Radio />} label='კი' />
          <FormControlLabel value='არა' control={<Radio />} label='არა' />
        </RadioGroup>
        {errors.selectedValue && (
          <span style={{ color: 'red', fontSize: '12px' }}>
            {errors.selectedValue}
          </span>
        )}
      </FormControl>

      {formData.selectedValue === 'კი' && (
        <div style={{ marginTop: '16px' }}>
          <TextField
            fullWidth
            label='სახელი'
            name='personFirstName'
            value={formData.personFirstName || ''}
            onChange={handleInputChange}
            margin='normal'
          />
          <TextField
            fullWidth
            label='გვარი'
            name='personLastName'
            value={formData.personLastName || ''}
            onChange={handleInputChange}
            margin='normal'
          />
          <TextField
            fullWidth
            label='ასაკი'
            name='personAge'
            type='number'
            value={formData.personAge || ''}
            onChange={handleInputChange}
            margin='normal'
          />
          <TextField
            fullWidth
            label='ელ-ფოსტა'
            name='personEmail'
            type='email'
            value={formData.personEmail || ''}
            onChange={handleInputChange}
            margin='normal'
          />
          <TextField
            fullWidth
            label='ტელეფონი'
            name='personPhone'
            type='tel'
            value={formData.personPhone || ''}
            onChange={handleInputChange}
            margin='normal'
          />
          <TextField
            fullWidth
            label='მისამართი'
            name='personAddress'
            value={formData.personAddress || ''}
            onChange={handleInputChange}
            margin='normal'
          />
        </div>
      )}
    </div>
  );
};

export default Step3;
